<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12">
        <indexHeader
          :title="$t('Partners')"
          :description="$t('From here you can control your partners and follow their accounts')"
          :showExport="'true'"
          :exportLink="path + '/export/excel'"
          :showImport="'true'"
        />
        <indexTable
          :searchText="$t('Find a partner')"
          :emptyTableText="$t('There are no partners')"
          :emptyTableSubText="$t('Try adding some items to the table and try again')"
          :buttonRole="$checkRole('partners_add')"
          :localData="true"
          :cloumns="[
            { column: 'name', title: $t('Partner name'), type: 'mainLink', sort: true },
            {
              column: 'mobile',
              title: $t('Phone number'),
              type: 'text',
              sort: true,
              icon: 'phone'
            },
            {
              column: 'balance',
              title: $t('Balance'),
              type: 'text',
              sort: true,
              icon: 'usd-square'
            },

            {
              column: 'stat',
              title: $t('Situation'),
              type: 'stat',
              sort: true,
              hideMobile: true
            },
            {
              column: 'options',
              title: $t('Settings'),
              type: 'options',
              options: [
                { name: 'show' },
                { name: 'edit', role: $checkRole('partners_edit') },
                {
                  name: 'link',
                  role: $checkRole('partners_deposits_add'),
                  title: 'إيداع إلي شريك',
                  icon: 'donate',
                  link: '/partnersDeposits/create?partner_id='
                },
                {
                  name: 'link',
                  role: $checkRole('partners_withdrawals_add'),
                  title: 'سحب من شريك',
                  icon: 'money-bill-alt',
                  link: '/partnersWithdrawals/create?partner_id='
                },
                { name: 'delete', role: $checkRole('partners_delete') }
              ]
            }
          ]"
          :deleteText="{
            attention: $t('Attention'),
            areYouReallySureToDeleteTheItem: $t(
              'Are You Really Sure About Deleting The Partner If You Delete The Partner All Invoices And Processes Will Be Deleted'
            ),
            close: $t('Close'),
            confirm: $t('Confirm'),
            loading: $t('Loading')
          }"
        />
      </div>
    </div>
    <importForm v-if="importShow"></importForm>
  </div>
</template>
<script>
import indexHeader from '@/elements/index/indexHeader.vue'
import indexTable from '@/elements/index/indexTable.vue'
import importForm from './components/importForm.vue'

export default {
  data() {
    return {
      path: '/partners',
      importShow: false
    }
  },
  methods: {
    importForm() {
      this.importShow = true
    }
  },
  components: {
    indexHeader,
    indexTable,
    importForm
  }
}
</script>
